module.exports = __webpack_public_path__ + "img/chevron-left.60209b0b.svg";